export default {"src":"/_next/static/media/arrow-bottom.b7179f65.svg","height":16,"width":16};